module.exports = __webpack_public_path__ + "static/assets/84a9455c54ab68ad8dcf8b6f6465ae71.svg";